import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    roulette: [],
    result: {},
    prizes: [],
    errors: {},
    sound: false
};

getters['fetchRoulette'] = function(state) { return state.roulette }
getters['fetchRoulettePrizes'] = function(state) { return state.prizes }
getters['fetchRouletteResult'] = function(state) { return state.result }
getters['fetchSound'] = function(state) { return state.sound }

const actions = {
    get(context) {
        return ApiService
            .get('roulette/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_ROULETTE', response.data);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            })
    },
    getPrizes(context) {
        return ApiService
            .get('roulette/prizes/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_ROULETTE_PRIZES', response.data);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            })
    },
    makeBet(context, payload) {
        return ApiService
            .post('roulette/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_BET', response.data);
            })
            .catch((response) => {
                if(response.status === 400){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            })
    },
    deleteBet(context, payload) {
        return ApiService
            .delete('roulette/delete_bet/' + payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('REMOVE_BET', payload);
            })
            .catch((response) => {
                if(response.status === 400 || response.status === 403){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            })
    },
    confirmBet(context) {
        return ApiService
            .get('roulette/confirm/')
            .then(() => {
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                if(response.status === 400){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            })
    },
    clear(context) {
        context.commit('CLEAR_ROULETTE');
    },
    setSound(context, payload) {
        context.commit('SET_SOUND', payload);
    },
    toggleSound(context) {
        context.commit('TOGGLE_SOUND');
    }
}

const mutations = {
    SET_ROULETTE(state, roulette) {
        state.roulette = roulette;
        state.errors = {};
    },
    SET_ROULETTE_PRIZES(state, prizes) {
        state.prizes = prizes;
        state.errors = {};
    },
    ADD_BET(state, bet) {
        state.roulette.push(bet);
        state.errors = {};
    },
    REMOVE_BET(state, betId) {
        for (let i in state.roulette) {
            if (state.roulette[i].id == betId) {
                state.roulette.splice(i, 1);
            }
        }
    },
    CLEAR_ROULETTE(state) {
        state.roulette = [];
    },
    SET_SOUND(state, sound) {
        state.sound = sound;
    },
    TOGGLE_SOUND(state) {
        state.sound = !state.sound;

        let setCookie = (cname, cvalue, exdays) => {
            let d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = 'expires=' + d.toUTCString();
            window.document.cookie = cname + '=' + cvalue + ';' +
                expires + ';path=/;sameSite=None;Secure';
        }
        let arr = [];
        arr.push(document.getElementById('timing-sound'));
        arr.push(document.getElementById('spin-sound'));
        arr.push(document.getElementById('win-roulette-sound'));
        arr.push(document.getElementById('lose-roulette-sound'));

        if (state.sound) {
            setCookie('rouletteSound', 1, 365);
        } else {
            setCookie('rouletteSound', 0, 365);
        }

        for (let i in arr) {
            if (state.sound) {
                arr[i].muted = false;
            } else {
                arr[i].muted = true;
            }
        }

    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
